import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'da-steps',
    templateUrl: './steps.component.html',
    styleUrls: ['./steps.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class StepsComponent implements OnInit {
    @Input() activeStep: number;
    constructor() {}

    ngOnInit() {}

    public isActive(currentStep: number) {
        if (currentStep < Number(this.activeStep)) {
            return true;
        }
    }

    public isCurrent(currentStep: number) {
        if (currentStep === Number(this.activeStep)) {
            return true;
        }
    }
}
